// extracted by mini-css-extract-plugin
module.exports = {"onlineIndicator":"Monitor_onlineIndicator__uDT0b","outerAwayIndicator":"Monitor_outerAwayIndicator__3LdAY","outerOfflineIndicator":"Monitor_outerOfflineIndicator__1u2fs"};